import { data } from 'autoprefixer'
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    businessMenu:false,
    columnData: [],
    footerData: [],
    pathData: [],
    navFlag: false,
    index: "",
    // 点击菜单栏的时候获取菜单栏某一项距离
    leftStyle: 0,
    // 控制图片所在的大div是否出现
    displayFlag: 'none',
    // // 根据不同的菜单栏给他不同的弥补的距离
    distance: 0,
    // 切换站点标志位
    siteListShow: false,
    //
    siteForm: {
      id: '',
      name: ''
    },
    name:"",
    keywords:"",
    description:"",
    logoUrl:"",
    phone:"",
    banner:"",

    topShow:true,
    height:90,
    name11:"",

    once:true,
    list:{
      username: '',
      openId: '',
      accessToken: ''
    }
  },
  actions: {
    LoginByUsername(context) {
        setTimeout(() => {
            context.commit('changeList')
    }, 1000)
  } 
},
  // mutations: {
  //   increment (state) {      // 变更状态
  //     state.once++
  //   }
  // },
  mutations: {
    changeList(state,data) {
      state.list = data
    },
    changeOnce(state, data) {
      state.once = data
    },
    changeName11(state, data) {
      state.name11 = data
    },
    changeHeight(state, data) {
      state.height = data
    },
    changeTopShow(state, data) {
      state.topShow = data
    },
    changeBusinessMenu(state,data) {
      state.businessMenu = data
    },
    changeBanner(state, data) {
      state.banner = data
    },
    changePhone(state, data) {
      state.phone = data
    },
    changeLogoUrl(state, data) {
      state.logoUrl = data
    },
    changeName(state, data) {
      state.name = data
    },
    changeKeyWords(state, data) {
      state.keywords = data
    },
    changeDescription(state, data) {
      state.description = data
    },
    changeColumn(state, data) {
      state.columnData = data
    },
    changePath(state, data) {
      state.pathData = data
    },
    changeNavFlag(state, data) {
      state.navFlag = data
      // console.log(state.navFlag);
    },
    changeIndex(state, data) {
      state.index = data
    },
    changeLeftStyle(state, data) {
      state.leftStyle = data
    },
    changeDisplayFlag(state, data) {
      state.displayFlag = data
    },
    changeDistance(state, data) {
      state.distance = data
    },
    changeSiteListShow(state, data) {
      state.siteListShow = data
    },
    changeSiteForm(state, data) {
      state.siteForm = data
    },
    changeFooterData(state, data) {
      state.footerData = data
    },
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js